/*
 * Copyright (c) 2020.
 * Project: Source
 * LastModified: 2/14/20, 3:23 PM
 * Author: diengv < Giáp Văn Điện >
 * Email: diengv@ominext.com
 * File name: mutations-type.js
 * File path: D:/Projects/PMS/Source/Client/vuejs/src/stores/mutations-type.js
 */

export default {
    updateOnlineFlag: 'UPDATE_ONLINE_FLAG',
    updatePrevRouter: 'UPDATE_PREV_ROUTER'
}
